import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/containerDomesticOrder/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/containerDomesticOrder',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/containerDomesticOrder',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/containerDomesticOrder/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/containerDomesticOrder',
    method: 'get',
    params: {
      id
    }
  })
}

export function saveCorrelation(data) {
  return request({
    url: '/api/business/containerDomesticOrder/saveCorrelation',
    method: 'post',
    data
  })
}

export function getCorrelationById(id) {
  return request({
    url: '/api/business/containerDomesticOrder/getCorrelationById',
    method: 'get',
    params: {
      id
    }
  })
}
export function getCopyCorrelationById(id) {
  return request({
    url: '/api/business/containerDomesticOrder/getCopyCorrelationById',
    method: 'get',
    params: {
      id
    }
  })
}
export function updateCorrelation(data) {
  return request({
    url: '/api/business/containerDomesticOrder/updateCorrelation',
    method: 'put',
    data
  })
}

export function finish(id) {
  return request({
    url: '/api/business/containerDomesticOrder/finish',
    method: 'post',
    params: {
      id
    }
  })
}

export function getGroupProductName() {
  return request({
    url: '/api/business/containerDomesticOrder/getGroupProductName',
    method: 'get'
  })
}